import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { DetParticipanteService } from 'src/app/service/det-participante.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';

import { DetParticipanteE,DetParticipanteM } from 'src/app/model/det-participante-bean';
import { MaeAVParticipantesM } from 'src/app/model/mae-aulavirtual-bean';
import { AuditoriaBeanM } from 'src/app/model/auditoria_bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';

import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-dml-participante',
  templateUrl: './dml-participante.component.html',
  styleUrls: ['./dml-participante.component.scss']
})
export class DmlParticipanteComponent implements OnInit {

  id_usuario:String;
  //variables enviado desde el padre
  x_titulo:String;
  id:number;
  c_tipo:String;
  id_constancia:String;

  muestra_nota:boolean;
  esupdate:boolean;
  seactualizaplantilla:boolean;
  permite_editar:boolean;

  listParticipantesAV = new Array<MaeAVParticipantesM>();
  //archivo
  x_file:File=null;
  @ViewChild('labelArchivo')
  labelArchivo: ElementRef;
  //agregar
  parti_Estado:number;
  ParticipanteE = new DetParticipanteE();
  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();


  page = 1;
  pageSize = 10;
  headElements = ['Nro','Nombre','Email','Nota',''];

  constructor(
    public  modalRefParticipanteDml: MDBModalRef,
    private utilitarioService:UtilitarioService,
    private globalVariablesService:GlobalVariablesService,
    private detParticipanteService:DetParticipanteService,
    private detArchivoService:DetArchivoService,
    private dialogo: MatDialog,
  ){}

  ngOnInit(): void {

    this.id_usuario= this.globalVariablesService.getC_usuario();
    this.muestra_nota=this.c_tipo==="19";
    this.seactualizaplantilla = false;

    if(this.id>0)
    {
      this.esupdate = true;
      this.cargarDatoInicial();
    }
    else
    {
      this.esupdate = false;
      this.permite_editar =true;
    }

  }
  cargarDatoInicial(){
    this.utilitarioService.loading = true;
    const cargarParticipante = this.detParticipanteService.get(this.id.toString()).toPromise()
    .then(result => {
      this.ParticipanteE = result[0];
      this.parti_Estado = this.ParticipanteE.c_estado as number;

      this.permite_editar = this.parti_Estado<24;
    });
    Promise.all([cargarParticipante])
    .then(response => {
      this.utilitarioService.loading = false;
    });
  }

  onAgregar(){

    if (this.validarFormulario()==false){
      return false;
    }

    let auditoriaBeanM = new AuditoriaBeanM();
    auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio('I');
    this.ParticipanteE.auditoriaBeanM = auditoriaBeanM;

    this.ParticipanteE.c_participante = 0;
    this.ParticipanteE.c_constancia = this.id_constancia;
    this.ParticipanteE.c_tipo = this.c_tipo;
    this.ParticipanteE.c_userid = "0";
    this.ParticipanteE.x_nro_constancia = "0";
    this.ParticipanteE.c_estado = 21;
    this.ParticipanteE.x_uid_doc = "0";
    this.ParticipanteE.x_uid_pdf = "0";
    this.ParticipanteE.l_envio_correo = "0";

    console.log(this.ParticipanteE);
    this.utilitarioService.loading=true;
    this.detParticipanteService.insert(this.ParticipanteE).subscribe((response_dml_bean:Response_dml_bean)=>{

      this.utilitarioService.loading=false;
      if (response_dml_bean.codigoRespuestaServicio=="1"){
        this.action.next(response_dml_bean);
        this.onClosemodal();
      }
      else
        this.utilitarioService.toastrInfo(response_dml_bean.mensaje);
    },
    error=>{
      this.utilitarioService.loading=false;
      console.log(error);
      this.utilitarioService.toastrError(error.error.messages.toString());
    });
  }

  onActualizar(){

    if (this.validarFormulario()==false){
      return false;
    }

    let auditoriaBeanM = new AuditoriaBeanM();
    auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio('U');
    this.ParticipanteE.auditoriaBeanM = auditoriaBeanM;

    this.utilitarioService.loading=true;
    this.detParticipanteService.update(this.ParticipanteE).subscribe((response_dml_bean:Response_dml_bean)=>{

      this.utilitarioService.loading=false;
      if (response_dml_bean.codigoRespuestaServicio=="1"){
        this.action.next(response_dml_bean);
        this.onClosemodal();
      }
      else
        this.utilitarioService.toastrInfo(response_dml_bean.mensaje);
    },
    error=>{
      this.utilitarioService.loading=false;
      console.log(error);
      this.utilitarioService.toastrError(error.error.messages.toString());
    });
  }

  validarFormulario() : Boolean{

    if (this.ParticipanteE.x_nombres=="" || this.ParticipanteE.x_nombres==null){
      this.utilitarioService.toastrError("Ingrese los nombres.");
      return false;
    }

    if (this.ParticipanteE.x_correo=="" || this.ParticipanteE.x_correo==null){
      this.utilitarioService.toastrError("Ingrese el correo.");
      return false;
    }
    if(this.muestra_nota)
    {
      if (this.ParticipanteE.x_nota=="" || this.ParticipanteE.x_nota==null){
        this.utilitarioService.toastrError("Ingrese la nota.");
        return false;
      }
    }
    else
      this.ParticipanteE.x_nota = '0';

    return true;

  }
  onActualizarPlantilla(){

    if (this.x_file==null){
      this.utilitarioService.toastrError("Seleccione un archivo.");
      return false;
    }
    if (this.x_file.size<=0){
      this.utilitarioService.toastrError("Seleccione un archivo.");
      return false;
    }

    this.utilitarioService.loading=true;
    // se sube el archivo con actualizacion del archivo
    let formData = new FormData;

    formData.append("file",this.x_file);
    this.detArchivoService.uploadPlantilla(formData,this.id_constancia.toString(),this.id.toString()).subscribe( (response_dml_bean : Response_dml_bean) => {

      this.utilitarioService.loading=false;
      if (response_dml_bean.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(response_dml_bean.mensaje);
        this.ParticipanteE.x_uid_doc = response_dml_bean.codigoRegistroBD;
        this.onMostrarActualizar(false);
      }
      else
        this.utilitarioService.toastrError(response_dml_bean.mensaje);
      console.log(response_dml_bean);
    },
    error=>{
      this.utilitarioService.toastrError("Hubo un error al guardar el archivo." + error.error.messages.toString());
      this.utilitarioService.loading=false;
    });
  }

  onEliminar()
  {
    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: '¿Desea eliminar el participante seleccionado?.'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {

      if (confirmado) {
        this.utilitarioService.loading=true;
        this.detParticipanteService.delete(this.id.toString()).subscribe( (response_dml_bean : Response_dml_bean) => {

          this.utilitarioService.loading=false;
          if (response_dml_bean.codigoRespuestaServicio=="1"){
            this.action.next(response_dml_bean);
            this.onClosemodal();
          }
          else
            this.utilitarioService.toastrError(response_dml_bean.mensaje);
          console.log(response_dml_bean);
        },
        error=>{
          this.utilitarioService.toastrError("Hubo un error al eliminar el participante." + error.error.messages.toString());
          this.utilitarioService.loading=false;
        });
      } else {
        return;
      }
    });
  }

  onFileChange(files: FileList){

    this.labelArchivo.nativeElement.innerText = Array.from(files)
      .map(f => f.name)
      .join(', ');

    this.x_file = files.item(0);
    console.log(files.item(0));

  }
  onMostrarActualizar(semuestr:boolean){

    if(semuestr)
    {
      this.seactualizaplantilla=true;
    }
    else
    {
      this.seactualizaplantilla=false;
      this.x_file = null;
    }
  }
  onDescargarArchivo(uid:string,ext:string){
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(uid).subscribe(blob=>{
      this.utilitarioService.loading = false;
      if(ext==='.docx')
        saveAs(blob,"plantilla_word_"+this.id+ext);
      else
        saveAs(blob,"constancia_"+this.id+ext);
    });
  }
  onClosemodal(){
    this.modalRefParticipanteDml.hide();
  }
}
